import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { SiteSettingsProvider } from "./context/SiteSettingsContext.jsx";
import { AlertProvider } from "./components/AppAlert.jsx";
import { LanguageProvider } from "./context/LanguageContext.jsx";
import { UploadQueueProvider } from "./context/UploadQueueContext.jsx";
import { ThemeProvider } from "./context/ThemeContext.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider>
      <SiteSettingsProvider>
        <AlertProvider>
          <LanguageProvider>
            <UploadQueueProvider>
              <App />
            </UploadQueueProvider>
          </LanguageProvider>
        </AlertProvider>
      </SiteSettingsProvider>
    </ThemeProvider>
  </StrictMode>
);